import { cn } from "@/lib/utils"

/**
 * Two-action modal footers: side-by-side with a small gap on small screens;
 * end-aligned with intrinsic button width from `sm` up.
 */
export function modalFooterClassName(className?: string) {
  return cn(
    "flex w-full min-w-0 flex-row flex-wrap items-center gap-2",
    "max-sm:[&>button]:min-w-0 max-sm:[&>button]:flex-1 max-sm:[&>button]:basis-0",
    "sm:justify-end sm:[&>button]:flex-none sm:[&>button]:basis-auto",
    className
  )
}

/** Full-width stacked actions with gap equal to default button height (Save above Delete, etc.). */
export function modalFooterStackedClassName(className?: string) {
  return cn(
    "flex w-full min-w-0 flex-col gap-10",
    "[&>button]:h-10 [&>button]:w-full",
    className
  )
}

/** Button row when footer also has metadata (e.g. selection count) beside actions. */
export function modalFooterActionsClassName(className?: string) {
  return cn(
    "flex w-full min-w-0 flex-row items-center gap-2",
    "max-sm:[&>button]:min-w-0 max-sm:[&>button]:flex-1 max-sm:[&>button]:basis-0",
    "sm:justify-end sm:[&>button]:flex-none sm:ml-auto",
    className
  )
}
